import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
    ...mapState('auth', ['currentUser', 'userLocations', 'selectedLocation']),
    ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', [
    'logIn',
    'logOut',
    'getLocations',
    'setSelectedLocation',
    'resetPassword',
    'saveProfilePicture',
    'deleteProfilePicture',
    'changeImage',
    'requestNewToken',
    'resetImage',
])
